import './App.css';
import React, {Component} from "react";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import RingVolumeIcon from '@material-ui/icons/RingVolume';
const deviceUUID = require('device-uuid');
const axios = require('axios');


const RequestStateEnum = Object.freeze({"validatingPath":1, "validPath":2, "invalidPath":3, "validatingRequest":4, "validRequest":5, "invalidRequest":6})

class App extends Component {

    constructor(props) {
    super(props);
    this.state = {
      // messageText : "Please wait while we page an associate..."
      //   requestState : RequestStateEnum.validating
    }
  }

  componentDidMount() {
     const params = new URLSearchParams(window.location.search);
     const store = params.get('store');
     const department = params.get('department');
     setTimeout(() =>  {
       this.handlePageLoad(store, department)
     }, 1000);
  }

  render() {
      if (this.state.requestState === RequestStateEnum.invalidPath) {
          return this.invalidPathView();
      } else if (this.state.requestState === RequestStateEnum.validPath) {
          return this.validPathView();
      } else if (this.state.requestState === RequestStateEnum.validatingRequest) {
          return this.validatingRequestView();
      } else if (this.state.requestState === RequestStateEnum.invalidRequest) {
          return this.invalidRequestView();
      } else if (this.state.requestState === RequestStateEnum.validRequest) {
          return this.validRequestView();
      } else {
          return this.validatingPathView();
      }
  }

  validatingPathView = () => {
      return (<div></div>);
  }

  invalidPathView = () => {
      return (<Grid container direction="row" style={{padding: "32px"}}>
          <Grid container direction="row" justify="center" alignItems="center" color={"primary"}>
              <RingVolumeIcon  style={{ fontSize: 80, margin: "24px", color: 'red'} }/>
          </Grid>
          <Grid container direction="row" justify="center" alignItems="center">
              <Typography variant="h5" align="center">
                  Oops! Invalid help request!
              </Typography>
          </Grid>
      </Grid>);
  }

  validPathView = () => {
      return (
          <Grid container direction="row" style={{padding: "32px"}}>
              <Grid container direction="row" justify="center" alignItems="center">
                  <RingVolumeIcon style={{ fontSize: 80, margin: "24px", color: 'red' }}/>
              </Grid>
              <Grid container direction="row" justify="center" alignItems="center" style={{paddingBottom: "20px"}}>
                  <Typography variant="h5" align="center">
                      Request Assistance
                  </Typography>
              </Grid>
              <Grid container direction="row" justify="center" alignItems="center">
                  <button className="buttonClass" onClick={this.requestHelp}>Request Help!</button>
              </Grid>
          </Grid>
      );
  }

  validatingRequestView = () => {
      return (
          <Grid container direction="row" style={{padding: "32px"}}>
              <Grid container direction="row" justify="center" alignItems="center" color={"primary"}>
                  <RingVolumeIcon  style={{ fontSize: 80, margin: "24px", color: 'red'} }/>
              </Grid>
              <Grid container direction="row" justify="center" alignItems="center">
                  <Typography variant="h5" align="center">
                      Requesting help ...
                  </Typography>
              </Grid>
          </Grid>
      );
  }

  invalidRequestView = () => {
      return (
          <Grid container direction="row" style={{padding: "32px"}}>
              <Grid container direction="row" justify="center" alignItems="center" color={"primary"}>
                  <RingVolumeIcon  style={{ fontSize: 80, margin: "24px", color: 'red'} }/>
              </Grid>
              <Grid container direction="row" justify="center" alignItems="center">
                  <Typography variant="h5" align="center">
                      Sorry! We could not process your request.
                  </Typography>
              </Grid>
          </Grid>
      );
  }

  validRequestView = () => {
      return (
          <Grid container direction="row" style={{padding: "32px"}}>
              <Grid container direction="row" justify="center" alignItems="center" color={"primary"}>
                  <RingVolumeIcon  style={{ fontSize: 80, margin: "24px", color: 'red'} }/>
              </Grid>
              <Grid container direction="row" justify="center" alignItems="center">
                  <Typography variant="h5" align="center">
                      Thank you! An associate will be with you shortly.
                  </Typography>
              </Grid>
          </Grid>
      );
  }

    comingSoonView = () => {
        return (
            <Grid container direction="row" style={{padding: "32px"}}>
                <Grid container direction="row" justify="center" alignItems="center" color={"primary"}>
                    <RingVolumeIcon  style={{ fontSize: 80, margin: "24px", color: 'red'} }/>
                </Grid>
                <Grid container direction="row" justify="center" alignItems="center">
                    <Typography variant="h5" align="center">
                        Coming Soon!
                    </Typography>
                </Grid>
            </Grid>
        );
    }

    requestHelp = (e) =>{
        e.preventDefault();

        let params = new URLSearchParams(window.location.search);
        let store = params.get('store');
        let department = params.get('department');
        // Log button tap event
        this.logButtonTapped(store, department)
        this.setState({ requestState: RequestStateEnum.validatingRequest});
        window.grecaptcha.ready(async () => {
            let token = await window.grecaptcha.execute(
                "6LdAi9wpAAAAAMcfSPytxGdLUcQaXM2O9NaU_nBD",
                { action: `help_request` }
            );
            let deviceId = await this.getDeviceId();
            let du = new deviceUUID.DeviceUUID().parse();
            let platform = du.platform;
            let browser = du.browser;
            let os = du.os;
            const requestData = {
                store: store,
                department: department,
                captcha: token,
                deviceId: deviceId,
                platform: platform,
                browser: browser,
                os: os
            };
            console.log(requestData);
            const options = {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                "Ocp-Apim-Subscription-Key": process.env.REACT_APP_API_KEY,
              },
              body: JSON.stringify(requestData),
            };
            const response =  await fetch(process.env.REACT_APP_API_URL + '/api/help-request', options);
            const responseData =  await response.json();
            if (response.status === 200) {
                console.log('Captcha passed');
                this.setState({ requestState: RequestStateEnum.validRequest});
            } else {
                console.log(responseData);
                this.setState({ requestState: RequestStateEnum.invalidRequest});
            };
        });
    }



    getDeviceId = () => {
        let di = localStorage.getItem('uniqueDeviceId');
        if (!di) {
            di = crypto.randomUUID();
            localStorage.setItem('uniqueDeviceId', di);
        }
        return di;
    }

  handlePageLoad = (store, department) => {
      if ((store === undefined || department === undefined) || (store === null || department === null)) {
      // show error message
        this.setState({ requestState: RequestStateEnum.invalidPath})
    } else {
          this.logPageLoad(store, department)
      // show CAPTCHA
        this.setState({requestState: RequestStateEnum.validPath})
    }
  }

    logEvent = async (detailTag, detailMessage, storeId) => {
        // get device information
        let deviceId = await this.getDeviceId();
        let du = new deviceUUID.DeviceUUID().parse();
        let platform = du.platform;
        let browser = du.browser;
        let os = du.os;
        detailMessage.deviceId = deviceId;
        detailMessage.platform = platform;
        detailMessage.browser = browser;
        detailMessage.os = os;

        let timestamp = new Date().toISOString();
        const dataBody = {
            time : timestamp,
            deviceId : "qr-paging-client",
            orgId: "53adb7b0-cde7-48a0-a6ca-7ca0f453ecae",
            origin: "qrsite",
            originModel: "client-site",
            event: "clientevent",
            details : {
                tag: detailTag,
                message: JSON.stringify(detailMessage)
            },
            userSettings : {
                site : storeId
            }
        };
        await axios.post("https://ems-pb-api.bluefletch.com/eventsAPI/apiv1/event", dataBody, {
            headers : {
                'x-bf-orgid': "53adb7b0-cde7-48a0-a6ca-7ca0f453ecae",
                'Content-Type': 'application/json'
            }
        });
    }

    logPageLoad = (store, department) => {
        const detailMsg = {
            department : `${department}`
        };
        this.logEvent("pageLoad", detailMsg, store);
    }

    logButtonTapped = (store, department) => {
        const detailMsg = {
            department : `${department}`
        };
        this.logEvent("requestButtonTapped", detailMsg, store);
    }
}

export default App;
